import React, { useEffect } from "react";
import { indexStore } from "../../store/indexStore";
import { Route, Routes, } from "react-router-dom";

import Branch from "../../branch/Branch";
import Menu from "../../branch/menus/Menu";
import Product from "../../branch/menus/product/Product";
import Cart from "../Cart/Cart";
import Orders from "../Cart/Orders";
import { TableProvider } from "../utils/TableContext";

const RestaurantRoutes: React.FC = () => {
  const { lang, fetchSettingsAction } = indexStore();
  useEffect(() => {
    fetchSettingsAction();
  }, []);
  return (
    <div
      className={`relative flex flex-col min-h-screen justify-between ${lang === "ar" ? "font-cairo" : lang === "en" ? "font-montserrat" : ""
        }`}
    >
      <TableProvider>
        <Routes>
          <Route path="/:branch_id" element={<Branch />} />
          <Route path="/:branch_id/:section_id" element={<Menu />} />
          <Route path="/:branch_id/cart" element={<Cart />} />
          {/* <Route path="/:branch_id/orders" element={<Orders />} /> */}
          <Route path="/:branch_id/:section_id/:product" element={<Product />} />
        </Routes>

      </TableProvider>
    </div>
  );
};

export default RestaurantRoutes;
